import { Tooltip } from 'react-tooltip';
import { Image } from 'theme-ui';
import QuestionMark from '@/assets/images/QuestionMark.svg';

type TooltipProps = {
  description: string;
  name: string;
};

export default ({ description, name }: TooltipProps) => {
  return (
    <>
      <Image
        alt="tooltip"
        src={QuestionMark}
        data-tooltip-id={`${name}-tooltipText`}
        data-tooltip-content={`${description}`}
        sx={{ marginBottom: '8px' }}
      />
      {/* For additional functionality check here: https://react-tooltip.com/ */}
      <Tooltip id={`${name}-tooltipText`} />
    </>
  );
};
